import { encrypt, decrypt } from '@/utils/crypt.ts'

export const useLocalKeys = () => {
  const save = (key: string, value: string | null | undefined) => {
    if (value) {
      localStorage.setItem(key, encrypt(value))
    } else {
      localStorage.removeItem(key)
    }
  }
  const get = (key: string) => {
    const value = localStorage.getItem(key)
    if (value) {
      return decrypt(value)
    } else {
      return undefined
    }
  }
  return {
    save,
    get,
  }
}
